
import { Base } from '../base-component';
import './switch-to-standard-bank.component.scss';

export class SwitchToStandardBank extends Base {

	constructor(element: Element ) {
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/switch-to-standard-bank/switch-to-standard-bank.component.ts